import { AbstractBlock } from 'starting-blocks'

export default class DummyBlock extends AbstractBlock {
  constructor(container) {
    super(container, 'DummyBlock')
    this.exampleElement = null
    this.active = false
  }

  init() {
    super.init()
    this.exampleElement = this.rootElement.querySelector('.js-example-element')
    console.log('DummyBlock', this.rootElement)
  }

  initEvents = () => {
    // init events here
    this.exampleElement.addEventListener('click', this.handleClick)
  }

  handleClick = async (e) => {
    e.preventDefault()
    console.log('clicked')
  }

  destroy() {
    super.destroy()
  }
}
